<template>
  <div :style="'height:'+getHeight()+'px;top:'+getCSSTop()+'px;'+'overflow:hidden;' + bgstyle" :class="shared ? 'shared-section scroll-section' : 'inline-section scroll-section'">
    <slot name="header" v-if="first"></slot>
    <div class="section-background" :style="'margin-left:'+marginValue.left.toString()+'%;'+bgstyle"></div>
    <!-- <video class="section-bg-video" autoplay="autoplay" loop="loop" controls data-vscid="cgy5ddi8q">
      <source src="src/assets/videos/holiday.mp4" type="'video/mp4'" />
      <source src="src/assets/videos/holiday.webm" type="'video/webm'" />
      <source src="src/assets/videos/holiday.ogv" type="'video/ogg'" />
    </video> -->
    <slot name="bgframe"></slot>
    <slot name="content"></slot>
    <a v-if="!first && !GeneralUtils.isMobile() && site == ''" class="prev-link glyphicon glyphicon-triangle-top" v-on:click="prevClicked" tabindex="0" role="button" aria-label="previous button"></a>
    <a v-if="!last && !GeneralUtils.isMobile() && site == ''" class="next-link glyphicon glyphicon-triangle-bottom" v-on:click="nextClicked" tabindex="0" role="button" aria-label="next button"></a>
    <slot name="footer" v-if="last"></slot>
  </div>
</template>
<script>
import {EventBus} from './utils/EventBus.js'
import {TweenLite} from 'gsap'
import GeneralUtils from './utils/GeneralUtils.js'
import Sections from './utils/Sections'
// import {TweenLite} from 'gsap'
export default {
  props: ['index', 'first', 'last', 'shared', 'zone', 'bgstyle', 'sidemargin', 'topoffset', 'mobiletop', 'mobileheight'],
  data () {
    return {
      GeneralUtils: GeneralUtils,
      mobileAlt: Sections.mobileAlternate(),
      verticalPosition: 0,
      wHeight: 0,
      site: Sections.getSite(),
      marginValue: {
        left: Number(this.sidemargin.toString())
      },
      bgID: 'bg_' + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('')
    }
  },
  watch: {
    zone: function () {
      var self = this
      // console.log('in zone = ' + this.zone.toString())
      if (self.zone === self.index) {
        TweenLite.to(self.$data.marginValue, 1, {left: 0})
      }
    }
  },
  methods: {
    sectionResize: function (e) {
      var self = this
      self.$data.wHeight = GeneralUtils.isMobile() ? GeneralUtils.getMobileHeight() : GeneralUtils.getHeight()
      self.$data.verticalPosition = self.wHeight * self.index
      EventBus.$emit('scroll-section-ease-resized', {index: self.index, shared: self.shared})
      console.log('resized')
      if (self.$data.mobileAlt && GeneralUtils.isMobile()) {
        let inlineSections = document.querySelectorAll('.inline-section')
        for (let i = 0; i < inlineSections.length; i++) {
          inlineSections[i].style.overflow = 'visible'
        }
      }
    },
    prevClicked: function (e) {
      var self = this
      EventBus.$emit('scroll-section-ease-complete', {index: self.index - 1})
    },
    nextClicked: function (e) {
      var self = this
      EventBus.$emit('scroll-section-ease-complete', {index: self.index + 1})
    },
    getHeight: function () {
      var self = this
      return GeneralUtils.isMobile() && Sections.inFrame() ? self.mobileheight : self.$data.wHeight
    },
    getVerticalPosition: function () {
      var self = this
      return self.shared ? 0 : self.$data.verticalPosition
    },
    getCSSTop: function () {
      var self = this
      return GeneralUtils.isMobile() && Sections.inFrame() ? self.mobiletop : self.getVerticalPosition() + self.topoffset
    },
    getSectionStyle: function () {
      var self = this
      var high = GeneralUtils.isMobile() ? GeneralUtils.getMobileHeight() : GeneralUtils.getHeight()
      var baseStyle = 'height:' + high + 'px;top:' + self.getVerticalPosition() + 'px;'
      // var baseStyle = 'height:' + self.getHeight() + 'px;top:' + self.getVerticalPosition() + 'px;'
      if (self.shared) {
        baseStyle += 'position: fixed;'
      }
      return baseStyle
    }
  },
  mounted: function () {
    var self = this
    self.sectionResize()
    window.addEventListener('resize', self.sectionResize)
  }
}
</script>
<style lang="scss" scoped>
div.scroll-section{
  position:absolute;
  left:0;
  right:0;
  background-image: none !important;
  > div.section-background{
    background-color: transparent !important;
  }
  > a {
    position:absolute;
    left: 50%;
    width: 50px;
    margin-left: -25px;
    color: #ffffff;
    /*display: none;*/
  }
  > a.prev-link {
    top: 5px;
  }
  > a.next-link {
    bottom: 5px;
  }
}
div.shared-section{
  > div.section-inner{
    z-index: 1000;
    > div{
      
    }
  }
}
div.inline-section{
 > div.section-inner{
   z-index: 1100;
    > div{
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollSection.vue